import React from 'react';
import Pill from '@99designs/frontend-components/components/Pill/Pill';
import TruncateText from '../../../components/TruncateText';
import Heading from '../../../components/Heading';
import { HeadingLink } from '../../../components/Link';
import StatsColumns from '../../../components/StatsColumns';
import Box from '../../../spa/core-components/Box';
import Paragraph from '../../Paragraph';
import VerticalSpacing from '../../VerticalSpacing';
import { Contest } from './ReviewCard';
import { getTitleForPackageType } from '../../../lib/getTitleForPackageType';

export interface Props {
    contest: Contest;
}

const DetailsTabContent = ({ contest }: Props) => (
    <Box paddingTop="space7" display="flex" flexDirection="column" flexGrow={1} height="100%">
        <Box>
            <Pill variations={['tag']}>{__('Finished')}</Pill>
        </Box>
        <VerticalSpacing verticalSpacing="space5" />
        <Heading type="h3" variations={['h5', 'no-margin']}>
            <HeadingLink href={contest.url} title={`See contest overview for ${contest.title}`}>
                <TruncateText text={contest.title} maxHeight={60} />
            </HeadingLink>
        </Heading>
        <VerticalSpacing verticalSpacing="space6" />
        {getTitleForPackageType(contest.packageType)}
        <VerticalSpacing verticalSpacing="space6" />
        <Paragraph variations={['soft', 'small', 'no-margin']}>
            <TruncateText text={contest.description} maxHeight={80} />
        </Paragraph>
        <Box paddingTop="space7" display="flex" flexGrow={1} alignItems="flex-end">
            <StatsColumns
                stats={[
                    { label: __('entries'), value: contest.entriesTotal },
                    { label: __('designers'), value: contest.designersTotal },
                ]}
            />
        </Box>
    </Box>
);

export default DetailsTabContent;
